import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category } from '@sb-tools/typescript/models/category.model';
import { environment } from '@environment';

@Injectable({ providedIn: 'root' })
export class CategoryService {
    constructor(private httpClient: HttpClient) {}

    get(allCategories?: boolean): Observable<Category[]> {
        return this.httpClient.get<Category[]>(environment.apiInboxUrl + 'categories', {
            params: new HttpParams().set('allCategories', allCategories),
        });
    }
}
